import { Button, Typography } from '@mui/material';
import { Tooltip } from 'style-guide';
import { useSelector } from 'react-redux';
import { STATUS } from 'constants/global-constants';

const StageButton = ({ stage, onHandleOpenDialog, stageName, loginUser, eXStatus }) => {
  const { disableBlink } = useSelector(state => state.predefinedData);
  const blinkerAnimation =  {
    '-webkit-animation': 'error-stage-glowing 1300ms infinite',
    '-moz-animation': 'error-stage-glowing 1300ms infinite',
    '-o-animation': 'error-stage-glowing 1300ms infinite',
      'animation': 'error-stage-glowing 1300ms infinite'
  }

  const baseClassName = "hover_none box_shadow_none tclog-status";
  const baseSx = { width: '100%', py: '3px', 'text-transform': 'none', fontSize: "0.8vw !important", height: "27px" };

  if (stage?.status === STATUS['4']) {
    return (
      <Tooltip title={stage?.notes}>
            <Button className={`${baseClassName} tclog-status-gray`} fontSize="12px" variant='contained' sx={baseSx} onClick={onHandleOpenDialog}>
                {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
        </Button>
      </Tooltip>
    );
  }

  if (stage?.status === STATUS['1']) {
    return (
      <Tooltip title={stage?.notes}>
            <Button className={`${baseClassName} tclog-status-blue`} fontSize="12px" variant='contained' sx={baseSx} onClick={onHandleOpenDialog}>
                {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
        </Button>
      </Tooltip>
    );
  }

  if (stage?.status === STATUS['2']) {
    return (
      <Tooltip title={stage?.notes}>
            <Button className={`${baseClassName} tclog-status-green`} fontSize="12px" variant='contained' sx={baseSx} onClick={onHandleOpenDialog}>
                {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
        </Button>
      </Tooltip>
    );
    }

    if (stage?.status === STATUS['3']) {
        return (
            <Tooltip title={stage?.notes}>
                <Button className={`${baseClassName} tclog-status-red`} fontSize="12px" variant='contained' sx={baseSx} style={!(disableBlink === null ? loginUser.disableBlink : disableBlink) ? blinkerAnimation : null} onClick={onHandleOpenDialog}>
                    {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
                </Button>
            </Tooltip>
        );
    }

    if (stage?.status === "CustomsPink") {
        return (
            <Tooltip title={stage?.notes}>
                <Button className={baseClassName} fontSize="12px" variant='contained' sx={{ ...baseSx, background: "pink !important", color: "black !important" }} style={!(disableBlink === null ? loginUser.disableBlink : disableBlink) ? blinkerAnimation : null} onClick={onHandleOpenDialog}>
                    {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
                </Button>
            </Tooltip>
        );
    }

    if (stage?.status === "CustomsYellow") {
        return (
            <Tooltip title={stage?.notes}>
                <Button className={baseClassName} fontSize="12px" variant='contained' sx={{ ...baseSx, background: "#e3d695 !important", color: "black !important" }} style={!(disableBlink === null ? loginUser.disableBlink : disableBlink) ? blinkerAnimation : null} onClick={onHandleOpenDialog}>
                    {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
                </Button>
            </Tooltip>
        );
    }

    if (stage?.status === "CustomsGreen") {
        return (
            <Tooltip title={stage?.notes}>
                <Button className={`${baseClassName} tclog-status-green`} fontSize="12px" variant='contained' sx={baseSx} style={!(disableBlink === null ? loginUser.disableBlink : disableBlink) ? blinkerAnimation : null} onClick={onHandleOpenDialog}>
                    {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
                </Button>
            </Tooltip>
        );
    }
    if (stage?.status === "CustomsAIGreen") {
        return (
            <Tooltip title={stage?.notes}>
                <Button className={`${baseClassName} tclog-status-green-ai`} fontSize="12px" variant='contained' sx={baseSx} style={!(disableBlink === null ? loginUser.disableBlink : disableBlink) ? blinkerAnimation : null} onClick={onHandleOpenDialog}>
                    {stageName}
                </Button>
            </Tooltip>
        );
    }

    if (stage?.status === "dissable") {
        return (
            <Tooltip >
                <Button disabled={true} className={`${baseClassName} tclog-status-darkgray`} fontSize="12px" variant='contained' sx={baseSx} style={!(disableBlink === null ? loginUser.disableBlink : disableBlink) ? blinkerAnimation : null} onClick={onHandleOpenDialog}>
                    {stageName} {eXStatus ? (<Typography sx={{ color: 'red' }}>&nbsp; x</Typography>) : ""}
                </Button>
            </Tooltip>
        );
    }
};

export default StageButton;
